export default __webpack_public_path__ + "static/praveen-67c834f91f36de79daf6b0709fb96137.png";